import { makeStyles } from '@material-ui/styles';

export default makeStyles({
    botonera: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 30
    },

    input: {
        display: 'none',
    },
});